import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import './rxjs-extensions';
import { AdminComponent } from './admin/admin.component';
import { HeaderComponent } from './header/header.component';
import { ExternalUserComponent } from './external-user/external-user.component';
import { LandingComponent } from './landing.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { RefundApproveComponent } from './refund-approve/refund-approve.component';
import { AccountExecutiveComponent } from './account-executive/account-executive.component';
// Primeng
import { TableModule } from 'primeng/table';
import { DataTableModule } from 'primeng/datatable';
import { PasswordModule, PanelModule, InputTextModule } from 'primeng/primeng';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { GrowlModule } from 'primeng/growl';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AdvanceDetailsComponent } from '@advancedetailcompenent/advance-details.component';
import { InvoiceDetailsComponent } from './external-user/invoice-details/invoice-details.component';
import { OrderDetailsComponent } from './external-user/order-details/order-details.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { HttpClientService } from '@authmanager/requestManager';
import { authManager } from '@authmanager/authManager';
import { AuthService } from './service/auth.service';
import { AdminService } from '@adminservice/admin.service';
import { AnnouncementComponent } from './announcement/announcement.component';
import { HeaderService } from '@headerservice/header.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExternalloginComponent } from './externallogin/externallogin.component';
import { ExternalRegistrationComponent } from './external-registration/external-registration.component';
import { DatePipe } from '@angular/common';

import { RecaptchaModule } from 'ng-recaptcha';
import { InputMaskModule } from 'primeng/inputmask';
import { ExternalChangePassword } from './externalchangepassword/externalchangepassword.component';
import { ExternalForgotPasswordComponent } from './external-forgot-password/external-forgot-password.component';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BlockCopyPasteDirective } from './shared/block-copy-paste.directive';
import { LogoutComponent } from './logout/logout.component';
import { AdvancePaymentStatusComponent } from '@advancedetailcompenent/advance-payment-status/advance-payment-status.component';
import { OrderInvoiceDetailsComponent } from './external-user/order-invoice-details/order-invoice-details.component';
import { OrderInvoiceStatusComponent } from './external-user/order-invoice-details/order-invoice-status/order-invoice-status.component';
import { RefundStatusComponent } from './refund-approve/refund-status/refund-status.component';
import { ChaseGatewayComponent } from './chase-gateway/chase-gateway.component';
import { InvoiceStatusComponent } from './external-user/invoice-details/invoice-status/invoice-status.component';
import { OrderStatusComponent } from './external-user/order-details/order-status/order-status.component';
import { InvoiceStatusProfileComponent } from './external-user/invoice-details/invoice-status/invoice-status-profile/invoice-status-profile.component';
import { OrderInvoiceStatusProfileComponent } from './external-user/order-invoice-details/order-invoice-status/order-invoice-status-profile/order-invoice-status-profile.component';
import { OrderStatusProfileComponent } from './external-user/order-details/order-status/order-status-profile/order-status-profile.component';
import { AdvancePaymentStatusProfileComponent } from '@advancedetailcompenent/advance-payment-status/advance-payment-status-profile/advance-payment-status-profile.component';
import { InternalinvoiceComponent } from './internalinvoice/internalinvoice.component';

import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { UserTypeGuard } from './user-type.guard';

import { FooterComponent } from './footer/footer.component';
import { ChaseTransactionLogsComponent } from './chase-transaction-logs/chase-transaction-logs.component';
import { ChaseTransactionLogsService } from './chase-transaction-logs/Service/chase-transaction-logs-service';
import { AgencyComponent } from './admin/agency/agency.component';
import { AgencyService } from './admin/agency/Service/agency.service';
import { GetEnvVarService } from './service/get-env-var.service';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    HeaderComponent,
    ExternalUserComponent,
    AdvanceDetailsComponent,
    InvoiceDetailsComponent,
    OrderDetailsComponent,
    LandingComponent,
    AnnouncementComponent,
    RefundApproveComponent,
    ExternalloginComponent,
    ExternalRegistrationComponent,
    AccountExecutiveComponent,
    ExternalChangePassword,
    ExternalForgotPasswordComponent,
    BlockCopyPasteDirective,
    LogoutComponent,
    AdvancePaymentStatusComponent,
    OrderInvoiceDetailsComponent,
    OrderInvoiceStatusComponent,
    RefundStatusComponent,
    ChaseGatewayComponent,
    InvoiceStatusComponent,
    OrderStatusComponent,
    InvoiceStatusProfileComponent,
    OrderInvoiceStatusProfileComponent,
    OrderStatusProfileComponent,
    AdvancePaymentStatusProfileComponent,
    InternalinvoiceComponent,
    FooterComponent,
	ChaseTransactionLogsComponent,
	// Arvind 
	AgencyComponent

  ],
  imports: [
    BrowserModule, BrowserAnimationsModule,
    HttpClientModule, AppRoutingModule, HttpModule,
    FormsModule, ReactiveFormsModule,
    NgbModule.forRoot(),
    // Primeng
    TableModule, DataTableModule, PasswordModule, PanelModule, InputTextModule,
    ButtonModule, DropdownModule, InputTextareaModule, TabViewModule, DialogModule,
    KeyFilterModule, MessagesModule, MessageModule, ConfirmDialogModule, GrowlModule,
    CalendarModule, CheckboxModule, AutoCompleteModule,
    ScrollPanelModule, CurrencyMaskModule, MatTooltipModule,
    InputMaskModule, RecaptchaModule.forRoot(), BsDatepickerModule.forRoot(), ProgressSpinnerModule
  ],
  providers: [authManager, AuthService, HttpClientService, NoopAnimationsModule, AdminService, HeaderService, DatePipe, UserTypeGuard, AgencyService, GetEnvVarService],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts